import { render, staticRenderFns } from "./top-notice.vue?vue&type=template&id=6bf4f526&scoped=true"
import script from "./top-notice.vue?vue&type=script&lang=js"
export * from "./top-notice.vue?vue&type=script&lang=js"
import style0 from "./top-notice.vue?vue&type=style&index=0&id=6bf4f526&prod&lang=scss&scoped=true"
import style1 from "./top-notice.vue?vue&type=style&index=1&id=6bf4f526&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf4f526",
  null
  
)

export default component.exports